import React, { useState } from "react";
import { ReactMultiEmail, isEmail } from 'react-multi-email';
import { inviteUsers } from "../../../Redux/actions/organization";
import { addNotification } from "../../../Utilities/notifications";
import "react-multi-email/style.css";
import axios from 'axios';

function InviteUsers(props) {

    let { organization } = props;

    const [loading, setLoading] = useState(false);
    const [emails, setEmails] = useState([]);
    const [role, setRole] = useState(1)
    const [err, setErr] = useState(false)


    const handleSubmit = async (e) => {
        e.preventDefault();
        let arr=[]
        for (const element of emails) {
            let {data}=await axios.get(`https://open.kickbox.com/v1/disposable/${element}`)
           arr.push(data.disposable)
        }
        let isemail = arr.indexOf(true) !== -1; 
        if(emails.length > 0 && emails.length <= 5 && !isemail){
            setLoading(true);
            let payload = {
                emails : emails,
                role_id : role
            }
            await inviteUsers(payload, organization.id );
            setLoading(false);
            props.invitationSuccess();
        }else{
            setErr(true)
            addNotification({
                title: "Techforce.ai",
                message: "Please Enter valid Business Emails",
                type:"danger"
              })
        }
    }

    return (<div className="invite-users-container">
            <ReactMultiEmail
                placeholder="Invite new user"
                emails={emails}
                onChange={(_emails: string[]) => {
                    setEmails(_emails)
                    setErr(false)
                }}
                validateEmail={async email => {
                    return isEmail(email) // return boolean
                }}
                getLabel={(
                    email: string,
                    index: number,
                    removeEmail: (index: number) => void
                ) => {
                    return (
                        <div data-tag key={index}>
                            {email}
                            <span data-tag-handle onClick={() => removeEmail(index)}>
                                ×
                            </span>
                        </div>
                    );
                }}
            />
            <small className="mb-4" style={{color:"#cccccc"}}>You can only invite 5 members at a time. </small>
            <div>{err && 
                <span className='error'>please enter valid business email id's</span>}
            </div>
            <div className="mt-2 mb-2">
                <label>Assign Roles</label>
                <hr style={{marginTop:"0px", marginLeft:"0px"}}/>
                <div className="roles-buttons">
                    <button name="admin" 
                            value={0} 
                            className={role === 1 ? "active" : ""} 
                            onClick={() => setRole(1)}>Admin</button>
                    <button name="member" 
                            value={1} 
                            className={role === 2 ? "active" : ""} 
                            onClick={() => setRole(2)}>Member</button>
                </div>
            </div>
            <div className="roles-buttons text-center mt-4 mb-2">
                <button style={{ color: "#02ce9d", border:"solid 1px #02ce9d", background:"none"}} 
                        onClick={() => props.toggle()}>Cancel</button>
                <button style={{ color: "#ffffff", border: "#02ce9d", background: "#02ce9d", boxShadow:"0 6px 10px 0 rgba(2, 206, 157, 0.33)"}} 
                        onClick={handleSubmit}>{loading ? <i
                                style={{ color: "#ffffff" }}
                                className="fas fa-circle-notch fa-spin"
                                ></i> : "Invite" }</button>
            </div>
        </div>
    );
}

export default InviteUsers;
